<script setup lang="ts">
import { ref, nextTick } from "vue";
import { Facade } from "@/drawing";
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";
import CanvasBusyOverlay from "@/components/canvas/CanvasBusyOverlay.vue";
import { trackTab } from "@/analytics/drawing-analytics";

const isRegenerating = ref(false);

function waitForRender(): Promise<void> {
  return new Promise((resolve) => {
    nextTick(() => setTimeout(resolve, 16));
  });
}

async function regenerate() {
  if (!Facade.isInitialized || isRegenerating.value) return;
  trackTab("settings", "regenerated");
  isRegenerating.value = true;
  await waitForRender();
  try {
    Facade.view.forceRegen();
  } finally {
    isRegenerating.value = false;
  }
}
</script>

<template>
  <button
    type="button"
    class="rounded option-btn w-100"
    :disabled="isRegenerating"
    @click="regenerate"
  >
    <div class="w-100 d-flex justify-content-between align-items-center gap-2">
      <div class="col d-flex flex-column text-start">
        <div class="text-truncate text-white">
          {{ $t("canvas:settings.regenerate.title") }}
        </div>
        <div class="text-grey" style="line-height: 15px !important">
          <small>{{ $t("canvas:settings.regenerate.desc") }}</small>
        </div>
      </div>
      <PhosphorIcon name="arrows-clockwise" :size="24" weight="duotone" />
    </div>
  </button>

  <Teleport to="body">
    <CanvasBusyOverlay
      v-if="isRegenerating"
      :status="$t('canvas:settings.regenerate.loading')"
    />
  </Teleport>
</template>
